import React, { Fragment } from 'react';

import axios from 'axios';
import { Credit2000PaymentInfo, PackageVisa } from '../ts/PackageResponse.ts';
import { PaxModel } from '../ts/PaxModel.ts';
import ReactCountryFlag from 'react-country-flag';

export const getAutocomplte = async (term: string) => {
  try {
    return (
      (await axios.post('Visa/Autocomplete', { term })).data?.countries
        ?.map((item) => ({
          value: item.code,
          label: item.textHe,
          html: (
            <Fragment>
              <ReactCountryFlag svg countryCode={item.code} className="ml-2" />
              {item.textHe}
            </Fragment>
          ),
        }))
        .sort((a, b) => a.label.localeCompare(b.label)) || []
    );
  } catch (error) {
    return [];
  }
};

export const getSearch = async (
  countryCode: string
): Promise<
  { availablePackages: PackageVisa[]; destinationPage: any } | undefined
> => {
  try {
    return (await axios.post('Visa/Search', { countryCode })).data;
  } catch (error) {
    return undefined;
  }
};

export const getAlpSearch = async (
  countryCode: string,
  token: string
): Promise<
  { availablePackages: PackageVisa[]; destinationPage: any } | undefined
> => {
  try {
    return (await axios.post('Visa/AlpSearch', { countryCode, token })).data;
  } catch (error) {
    return undefined;
  }
};

export const getDest = async (): Promise<PackageVisa[] | undefined> => {
  try {
    return (await axios.post('Visa/AllDestinations')).data.destinations.filter(
      (des) => !!des.listOfGalleryId?.length
    );
  } catch (error) {
    return undefined;
  }
};

interface BookResponse {
  data: Credit2000PaymentInfo;
  useCreditCard: boolean;
}
export const book = async (
  pax: PaxModel,
  packageUKey: string
): Promise<BookResponse | undefined> => {
  try {
    const response = await axios.post('Visa/Book', { pax, packageUKey });
    return {
      data: response.data.data.credit2000PaymentInfo,
      useCreditCard: response.data.useCreditCard,
    };
  } catch (error) {
    return undefined;
  }
};

export const bookAlp = async (
  pax: PaxModel,
  packageUKey: string,
  token: string | null
): Promise<BookResponse | undefined> => {
  try {
    const response = await axios.post('Visa/AlpBook', {
      pax,
      packageUKey,
      token,
    });
    return {
      data: response.data.data.credit2000PaymentInfo,
      useCreditCard: response.data.useCreditCard,
    };
  } catch (error) {
    return undefined;
  }
};

export const bookComplete = async (
  pax: PaxModel,
  packageUKey: string,
  creditCard: boolean,
  token: string | null,
  paymentSettings?: Credit2000PaymentInfo
): Promise<any | undefined> => {
  try {
    if (token) {
      return (
        await axios.post('Visa/AlpBookComplete', {
          pax,
          packageUKey,
          creditCard,
          paymentSettings,
          token,
        })
      ).data;
    } else {
      return (
        await axios.post('Visa/BookComplete', {
          pax,
          packageUKey,
          creditCard,
          paymentSettings,
        })
      ).data;
    }
  } catch (error) {
    return undefined;
  }
};

export const checkPaymentStatus = async (
  transactionId: string
): Promise<any | undefined> => {
  try {
    return (await axios.post('Visa/CheckPaymentStatus', { transactionId }))
      .data;
  } catch (error) {
    return undefined;
  }
};

export const base64ToFile = (
  base64: string,
  fileName: string,
  mimeType: string
): File => {
  const byteString = atob(base64);
  const byteArray = new Uint8Array(byteString.length);

  for (let i = 0; i < byteString.length; i++) {
    byteArray[i] = byteString.charCodeAt(i);
  }

  return new File([byteArray], fileName, { type: mimeType });
};

export interface VisaAlpLoginInput {
  info: any;
  token?: string;
  language: string;
}

export const visaAlpLogin = async (input: VisaAlpLoginInput): Promise<any> => {
  try {
    const response = await axios.post('Visa/VisaAlpLogin', input);
    return response.data;
  } catch (error) {
    return undefined;
  }
};
